import { ArrowForwardIcon, Tile } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Constants from '../../Constants';
import Link from '../Link';

import { StyledLink, StyledP } from './ContactUsTile.styles';

export interface ContactUsTileProps { }

const ContactUsTile: FC<ContactUsTileProps> = () => {
  const { t } = useTranslation('ContactUsTile');

  return (
    <Tile titleAs="h2" title={t('contactUsTitle')} isDivided={false}>
      <StyledP>{t('contactUsText')}</StyledP>
      <StyledLink>
        <Link redirectTo={`/${Constants.ContactUsPagePath}`} RightIcon={ArrowForwardIcon}>{t('linkText')}</Link>
      </StyledLink>
    </Tile>
  );
};

export default ContactUsTile;
